export default {"src":"/_next/static/media/earn.540ee8b3.svg","height":64,"width":65,"blurWidth":0,"blurHeight":0};